/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 15:50:31 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { Fragment, useState, useRef } from 'react';
import {
  Datagrid,
  EditButton,
  NumberField,
  Pagination,
  ReferenceManyField,
  TextField,
  FunctionField,
  Link,
} from 'react-admin';
import debounce from 'lodash.debounce';
import { Add } from '@material-ui/icons';
import ProjectFilters from './filter';
import { LinkButton as CreateButton } from 'Components/Buttons';
import { tabbedLists } from 'styles';
import { isManager, isProjectManager } from 'utils/roles';
import { PostPagination } from '../../../../Components/CustomPagination/pagination';
// Note! The following error may appear in the console:
// "Total from response is not a number. Please check your dataProvider or the API."
// This is a known bug in react-admin: https://github.com/marmelab/react-admin/issues/4337

const ProjectTab = ({
  className,
  component,
  formValues,
  permissions,
  ...props
}) => {
  const classes = tabbedLists();
  const canCreate = isManager(permissions, props.id);
  const [projectFilter, setProjectFilter] = useState({});

  // we use just a regular react state here as it is only one filter
  // if we need multiple filters will need to store the filter in redux state
  const setFilter = filter => {
    const currentFilter = projectFilter;
    if (currentFilter !== filter) {
      if (filter) {
        return setProjectFilter({ name: filter });
      }
      return setProjectFilter({});
    }
  };

  const delayedSetFilter = useRef(debounce(filter => setFilter(filter), 750))
    .current;

  const onFilterChange = event => {
    if (event.target) return delayedSetFilter(event.target.value);
    return delayedSetFilter();
  };

  return (
    <Fragment>
      <div className={classes.listFilterCreate}>
        <ProjectFilters setFilters={onFilterChange} />
        {permissions && canCreate ? (
          <CreateButton
            label={'ra.action.create'}
            pathname={'/Project/create'}
            state={{
              record: {
                organisationId: props && props.record ? props.record.id : null,
              },
            }}
            icon={<Add />}
          />
        ) : null}
      </div>
      <ReferenceManyField
        reference="Project"
        target="organisation"
        source="id"
        filter={projectFilter}
        pagination={<PostPagination />}
        bulkActionButtons={false}
        {...props}
      >
        <Datagrid
          className={classes.root}
          rowClick={(id, basePath, record) => {
            return isProjectManager(permissions, record.id)
              ? {
                  pathname: `/Project/${record.id}`,
                  state: {
                    organisationId:
                      props && props.record ? props.record.id : null,
                  },
                }
              : null;
          }}
        >
          <TextField
            source="name"
            label={'resources.Project.fields.project'}
            sortable={false}
          />
          <NumberField
            source="statistics.numberOfSites"
            label={'resources.Project.fields.numberOfSites'}
            sortable={false}
          />
          <NumberField
            source="statistics.numberOfUsers"
            label={'resources.Project.fields.numberOfUsers'}
            sortable={false}
          />
        </Datagrid>
      </ReferenceManyField>
    </Fragment>
  );
};

export default ProjectTab;
